import {
  aboutFreeFormSection,
  finalCTASection,
  geotaggedProjectsSection,
  homeHeroSection,
  servicesSection,
} from "../sections/individualSections";

const ABOUT_SECTIONS = [
  homeHeroSection,
  aboutFreeFormSection,
  servicesSection,
  geotaggedProjectsSection,
  finalCTASection,
];

export default ABOUT_SECTIONS.map((s, idx) => ({ ...s, order: idx + 1 }));
